import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { CheckCircle2, Droplets, Wrench, Leaf, FileText, ClipboardList } from "lucide-react";
export default function PropertyManagementReliableAndComprehensive() {
  const services = [{
    id: 1,
    icon: Droplets,
    title: "Flächenreinigung ohne chemische Zusätze",
    description: "Professionelle Reinigung von Terrassen, Einfahrten, Pflaster, Parkplätzen und Spielplätzen ausschließlich mit Wasser und Hochdrucktechnik."
  }, {
    id: 2,
    icon: Wrench,
    title: "Hausmeistertätigkeiten",
    description: "Umfassende Hausmeisterservices im nicht handwerkspflichtigen Bereich für Privathaushalte, Hausverwaltungen und Unternehmen."
  }, {
    id: 3,
    icon: Leaf,
    title: "Gartenpflege",
    description: "Hecken- und Rasenschnitt, Strauchschnitt, Laubbeseitigung und saisonale Gartenpflege für gepflegte Außenanlagen."
  }, {
    id: 4,
    icon: FileText,
    title: "Bürotätigkeiten",
    description: "Professionelle Unterstützung bei administrativen Aufgaben und Büroorganisation für effiziente Geschäftsabläufe."
  }, {
    id: 5,
    icon: ClipboardList,
    title: "Hilfeleistungen im Bereich Büroorganisation",
    description: "Hilfe bei der Strukturierung und Optimierung Ihrer Büroabläufe sowie bei organisatorischen Aufgaben."
  }];
  const benefits = ["Umweltfreundliche Flächenreinigung nur mit Wasser und Hochdrucktechnik", "Zuverlässige Hausmeistertätigkeiten im nicht handwerkspflichtigen Bereich", "Professionelle Gartenpflege das ganze Jahr", "Effiziente Bürotätigkeiten und administrative Unterstützung", "Umfassende Hilfe bei Büroorganisation und Strukturierung"];
  return <section className="relative bg-background py-16 sm:py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {}
     

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12 lg:mb-16">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className="bg-muted-light border border-border shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] animate-fade-in-up" style={{
            animationDelay: `${i * 100}ms`
          }}>
                <CardHeader>
                  <div className="size-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                    <Icon className="size-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl">{service.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-sm leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>

        {}
        <div className="bg-muted-light rounded-xl border border-border shadow-soft p-6 sm:p-8 lg:p-10 mb-12 lg:mb-16 animate-fade-in-up-delay-200">
          <h3 className="text-2xl sm:text-3xl font-semibold text-foreground mb-6 text-center">
            Alle Leistungsbereiche auf einen Blick
          </h3>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto">
            {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-3 text-muted-foreground">
                <CheckCircle2 className="size-5 text-primary shrink-0 mt-0.5" />
                <span className="text-sm sm:text-base leading-relaxed">{benefit}</span>
              </li>)}
          </ul>
        </div>

        {}
        <div className="text-center animate-fade-in-up-delay-200">
          <p className="text-base sm:text-lg text-muted-foreground mb-6">
            Kontaktieren Sie uns für ein kostenloses Angebot – wir beraten Sie gerne zu allen Dienstleistungen!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/KontaktPage">
              <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary-hover shadow-md hover:shadow-medium hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] px-8">
                Kostenloses Angebot anfordern
              </Button>
            </Link>
            <Link to="/ReinigungPage">
              <Button variant="outline" size="lg" className="shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] px-8">
                Mehr über unsere Leistungen
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}